import {useAppDispatch, useAppSelector} from "../../redux/redux.hook";
import React, {useContext} from "react";
import {getUserRoleThunk, logoutThunk} from "./auth.thunk";
import {selectUserRole} from "./auth.slice";
import {AuthContext} from "../components/AuthProvider";

export function useUserRole(foreignUserId?: string) {

    const { userId }= useContext(AuthContext);

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if(userId) {
            dispatch(getUserRoleThunk({userId: foreignUserId ?? userId}))
        }
    }, [dispatch, foreignUserId, userId]);

    return useAppSelector(selectUserRole);
}

export function useLogout() {
    const dispatch = useAppDispatch();
    return {logout: () => dispatch(logoutThunk())}
}